import { DecimalPipe } from '@angular/common';
import get from 'lodash-es/get';
import OrderPaymentAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity';
import { formatDate , getStatusName} from './order-payment-c-list.utils';
import { ExportTaskProcessor } from 'app/layout/export-overlay/tasks/core/processors/export-task-processor';

export class OrdersPaymentCListCommonExportProcessor extends ExportTaskProcessor {
  constructor(protected decimalPipe: DecimalPipe) {
    super();
  }

  protected transformForMainSection(item: OrderPaymentAttributes) {
    return {
        trip: get(item, 'trip.id', '??'),
        route: `${get(item, 'subRoute.id', '??')} ${get(item, 'subRoute.name', '??')}`,
        user: get(item, 'user', '??'),
        date: formatDate(item.trip?.dateHourStart),
        serial: get(item, 'documents_count', '??'),
        totalPayingAmount: this.decimalPipe.transform(get(item, 'totalPayingAmount', '??'),'1.2-2'),
        totalPayingRealAmount: this.decimalPipe.transform(get(item, 'totalPayingRealAmount', '??'),'1.2-2'),
        totalPaymentReviewCountSend: this.decimalPipe.transform(get(item, 'totalPaymentReviewCountSend', '??'),'1.2-2'),
        amountNotVerified: this.decimalPipe.transform(get(item, 'amountNotVerified', '??'),'1.2-2'),
        paymentReviewPercentage:get(item, 'paymentReviewPercentage', '??'),
        paymentReviewPercentageERP:get(item, 'paymentReviewPercentageERP', '??'),
    };
  }

  protected transformForDetailsSection(item: OrderPaymentAttributes) {
    return get(item, 'orders', []).flatMap((detail) => {
        return get(detail, 'shipDetail', []).flatMap((ship) => {
            return get(ship, 'orders', []).map((order) => ({
            route: get(item, 'subRoute.name', '??'),
            user: get(item, 'user', '??'),
            shipToName: get(detail, 'shipToName', '??'),
            bank: get(ship, 'bank', '??'),
            accountNumber: get(ship, 'accountNumber','??'),
            serials: get(detail, 'serials', '??'),
            documentType: get(order, 'documentType', '??'),
            document: get(order, 'document', '??'),
            dateHour: formatDate(get(detail, 'dateHour', '??') as string, true),
            paymentType: get(ship, 'paymentType', '??'),
            paying: get(order, 'paying', '??'),
            operationNumber: get(ship, 'operationNumber', '??'),
            paymentReview: getStatusName(detail.paymentReview),
            comment: get(order, 'comment', '??'),
        }));
    });
});
  }
}
